import axios from "axios";
import { computed } from "vue";

import type { AuthenticatedUser } from "@/models/authenticated_user";
import { createWorkOSAuth } from "@/utils/workos";

export const authenticatedApi = axios.create();
type Options = Omit<Parameters<typeof createWorkOSAuth>[0], "api">;

const createAuthentication = (options: Options) => {
  const adapter = createWorkOSAuth({ ...options, api: authenticatedApi });
  const user = computed<AuthenticatedUser | undefined>(() => {
    const profile = adapter.user.value;
    if (!profile) return undefined;
    return {
      sub: profile.id,
      name:
        [profile.firstName, profile.lastName].filter(Boolean).join(" ") ||
        profile.email,
      firstName: profile.firstName ?? "",
      lastName: profile.lastName ?? "",
      email: profile.email,
      picture: profile.profilePictureUrl ?? undefined,
    };
  });
  return { ...adapter, user };
};

let authentication: ReturnType<typeof createAuthentication> | undefined;

export const configureAuthentication = (options: Options) => {
  if (authentication) throw new Error("Authentication is already configured");
  authentication = createAuthentication(options);
  return authentication;
};

export const useAuth = () => {
  if (!authentication)
    throw new Error("Authentication must be configured before use");
  return authentication;
};
